export const PageInfo = {
    "pendingOrder":"", //sample value (Yes or No based on customer response on gborder page) 
    "businessUnit":"",// Sample value (SMB) (If all new fios pages are under SMB then use SMB as default value)
    "siteCategory":"",// sample value (FIOS Business Internet)(Check with devs and archs)
    "country":"us", //Details about this object are in next few pages
    "region":"na", //Details about this object are in next few pages
    "languageSelected":"", //Details about this object are in the next few pages. Example: en
    "url":"", //URL of the currently viewed page. Example: https://verizon.com
    "pageName":"", //Details about this object are in next few pages,
    "friendlyPageName": "",// example (check availability, out-of-franchise, customize-order etc.,)
    "componentName":"",//Name of the component (refer to Tagging strategy component name field) 
    "pageType":"", // Defines the type of page for the currently viewed page (check table in next Page)
    "siteSectionsLevel1":"", //Set to undefined if value is not available
    "siteSectionsLevel2":"", // Set to undefined if value is not available
    "siteSectionsLevel3":"", // Set to undefined if value is not available
    "siteSectionsLevel4":"", // Set to undefined if value is not available
    "siteSectionsLevel5":"", // Set to undefined if value is not available
    "siteSectionsLevel6":"", // Set to undefined if value is not available
    "siteSectionsComplete":"", //Complete folder structure concatenated together
    "previousPageURL": ""
};

export const VzdlPageInfo = {
    articleId : '',
    channel : 'smb', //site section
    channelSession : '',
    detail : '',
    displayChannel : '',
    flow : '',
    name : '',
    sourceChannel : 'fios',
    subFlow:'',//For Wireless
    throttle:'' ,
    contentFragments:'',
    link:'', 
    LQZip:'',
    fraudIndicator:'',
    vendorPartnerId:'',
    repeatLQSVisitor:'',
    repeatCartVisitor:'',
    fireProactiveChat:'',
    language:'en'
};

export const qualifyForInternet=  {
    Zipcode: "", //Addressvalidationpage.selectedzipcode.zip,
    Qualifyresponse:"" // Addressvalidationpage.isFiosQualified
};

export const saveCart = { 
    saveCartComplete: "" , //True or False
    orderExperience: "" ,// Order experience radio button value clicked by user
    cartId:""  // If not available then don’t pass or include "unknown" 
};

export const shoppingCartInfo = {
    //Pass response data from GetFloatCart Network call
}; //end shoppingCartInfo

export const pageMapObj = {
    "AddressValidationPage": {
        friendlyPageName: "Check Availability",
        pageType: "Service Availability"
    },
    "OutofFranchise": {
        friendlyPageName: "Out of Franchise",
        pageType: "Service Availability"
    },
    "CustomizeOrder": {
        friendlyPageName: "Customize-order",
        pageType: "Product Page"
    },
    "Checkout": {
        friendlyPageName: "Check Out Page",
        pageType: "Checkout"
    },
    "Confirmation": {
        friendlyPageName: "Cart Submission Confirmation",
        pageType: "Confirmation "
    },
    "SaveCart": {
        friendlyPageName: "Save Cart Form",
        pageType: "Save Cart"
    },
    "SaveCartConfirmation": {
        friendlyPageName: "Save Cart Confirmation",
        pageType: "Save Cart"
    },
    "ContactRep": {
        friendlyPageName: "Contact Representative",
        pageType: "Contact Rep"
    },
    "PendingOrder": {
        friendlyPageName: "Pending Order",
        pageType: "Pending Order"
    },
    "FIOSRegistratoion": {
        friendlyPageName: "FIOS Registration",
        pageType: "FIOS Registration"
    },
    "ConfirmationContactRep": {
        friendlyPageName: "Order Confirmation Contact Representative",
        pageType: "Confirmation Contact Rep"
    },
    "OptixCheckout": {
        friendlyPageName: "Optix Checkout",
        pageType: "Optix Checkout"
    },
    "OptixOrderConfirmation": {
        friendlyPageName: "Optix Order Confirmation",
        pageType: "Optix Order Confirmation"
    }
}